import React from "react";
import PropTypes from "prop-types";

import {
  isBirthday,
  isAnniversary,
  isValentinesDay,
  isMotherDay,
  isFatherDay,
  defaultValue,
} from "utils/calendarUtils";
import aniversaryDay from "assets/images/occasions/aniversaryDay.png";
import fathersDay from "assets/images/occasions/fathersDay.png";
import mothersDay from "assets/images/occasions/mothersDay.png";
import valentinesDay from "assets/images/occasions/valentinesDay.png";
import partyHat from "assets/images/party-hat.png";
import ResponsiveImage from "components/ResponsiveImage";

import useStyles from "./useStyles";

const Icon = ({ occasion = defaultValue }) => {
  const classes = useStyles();
  const isDefaultBirthday = isBirthday(occasion);

  const getImage = () => {
    switch (true) {
      case isBirthday(occasion):
        return partyHat;
      case isAnniversary(occasion):
        return aniversaryDay;
      case isValentinesDay(occasion):
        return valentinesDay;
      case isMotherDay(occasion):
        return mothersDay;
      case isFatherDay(occasion):
        return fathersDay;
      default:
        return partyHat;
    }
  };

  return (
    <div className={isDefaultBirthday ? classes.defaultBirthday : classes.defaultOccasion}>
      <ResponsiveImage
        className={isDefaultBirthday ? classes.imageBirthday : classes.imageOccasion}
        alt={occasion}
        src={getImage()}
        width={isDefaultBirthday ? 34 : 54}
        widthMobile={isDefaultBirthday ? 28 : 40}
      />
    </div>
  );
};

Icon.propTypes = {
  occasion: PropTypes.string,
};

export default Icon;
